const appQueryParams = {
  lang: 'lang',
};

export default appQueryParams;
